<template>
<div class="chapter">
<div class="inner_page">
<div class="generated-style-2" id="hryeacknowledgments">
<p class="chapter-head" xml:lang="en-us">ACKNOWLEDGMENTS</p>
<p class="body" xml:lang="en-us"><span class="no-style-override-9">I would like to thank my friend and fellow historian, Harold Dellinger, who had a major role in the conception of this project. His interest in the Rebel Yell sparked my own, and his encouragement during the writing of this book helped keep it moving.</span></p>
<p class="body" xml:lang="en-us">I would also like to thank another friend, Vicki Beck, who has been helpful to me in many ways through the years. She had the good sense to remind me that the important thing about writing was to continue to enjoy it.</p>
<p class="body" xml:lang="en-us"><span class="no-style-override-9">I also want to recognize the researchers and historians whose previous work on the Rebel Yell served as a foundation on which I was able to build. I especially wish to thank Monte Akers (historian, author and friend), S. Waite Rawls III and John Coski of the Museum of the Confederacy, and authors Clint Johnson and Steve Cottrell for the valuable time they gave me in discussing various aspects of the subject.</span></p>
<p class="body" xml:lang="en-us">Finally, I want to give thanks to my wife, “Sam,” who always supports and never complains.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?73e7bfd4